"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.evaluateDateFormula = exports.evaluateStartAndEndDateFormulas = void 0;
const common_1 = require("@finley-technologies/common");
const finley_types_1 = require("@finley-technologies/finley-types");
const create_1 = require("./create");
const utils_1 = require("./utils");
/**
 * This ensures that we always convert to desired "FullDateStr" type, making it
 * easier for users in case they forget to wrap this (since it's always needed).
 * Even if they do wrap it in the formula already, this is fine as this extra
 * "TEXT" wrap will just result in the same output
 */
const _wrapTextFormula = (formula) => {
    return `TEXT(${formula}, "yyyy-mm-dd")`;
};
const evaluateStartAndEndDateFormulas = (params) => {
    const { endFormula, startFormula, variables } = params;
    const updatedStartFormula = _wrapTextFormula(startFormula);
    const updatedEndFormula = _wrapTextFormula(endFormula);
    const formulaEngine = (0, create_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [updatedStartFormula, updatedEndFormula], undefined);
    const { keyMap, errors } = (0, utils_1.keyByVariableName)(variables);
    (0, common_1.finleyAssert)(errors.length === 0, `Incurred errors when creating variables [${errors.join(', ')}]`);
    formulaEngine.setVariables(keyMap);
    const startDate = formulaEngine.evaluateFullDateStr(updatedStartFormula);
    const endDate = formulaEngine.evaluateFullDateStr(updatedEndFormula);
    return { startDate, endDate };
};
exports.evaluateStartAndEndDateFormulas = evaluateStartAndEndDateFormulas;
const evaluateDateFormula = (params) => {
    const { dateFormula, variables } = params;
    const updatedFormula = _wrapTextFormula(dateFormula);
    const formulaEngine = (0, create_1.createFormulaEngine)(finley_types_1.FormulaEngine.SupportedFormulaEngines.HyperFormula1, [updatedFormula], undefined);
    const { keyMap, errors } = (0, utils_1.keyByVariableName)(variables);
    (0, common_1.finleyAssert)(errors.length === 0, `Incurred errors when creating variables [${errors.join(', ')}]`);
    formulaEngine.setVariables(keyMap);
    return formulaEngine.evaluateFullDateStr(updatedFormula);
};
exports.evaluateDateFormula = evaluateDateFormula;
//# sourceMappingURL=commonFormulas.js.map